import React from 'react'
import { BrowserRouter as Router, Route ,Switch } from 'react-router-dom'
import Footer from './components/footer/footer';
import DetailCertifictes from './components/certificates/detail';
import Home from './pages/home/home';
import SkillAllApp from './components/skills/skill-all-app';
import ProjectsAll from './components/projects/projectall';
import CertificatesAll from './components/certificates/certificates-all';
import DetailSkill from './components/skills/detail';
import DetailProjects from './components/projects/detail';
import GlobalStyle from './globalStyle';
import LeftArrow from './components/left-arrow/arrow';
import SkillDetail from './components/skills/detail';
export const url = 'https://adam-cv.herokuapp.com/api'
const Routing = () => {

  return(
    <Switch>
      <Route exact path='/'>
        <Home />
        <Footer />
      </Route>
      <Route path='/certificates-all'>
        <LeftArrow />
        <CertificatesAll />
        <Footer />
      </Route>
      <Route path='/certificates/:id'>
        <LeftArrow />
        <DetailCertifictes />
        <Footer />
      </Route>
      <Route exact path="/skills">
        <LeftArrow />
        <SkillAllApp />
        <Footer />
      </Route>
      <Route path='/skills/:id'>
        <LeftArrow />
        <SkillDetail />
        <Footer />
      </Route>
      <Route path='/project-all'>
       <LeftArrow />
        <ProjectsAll />
        <Footer />
      </Route>
      <Route path='/projects/:id'>
       <LeftArrow />
        <DetailProjects />
        <Footer />
      </Route>
 
    </Switch>
  )
}

function App(){
  return(
      <Router>
          <GlobalStyle />
          <Routing />
      </Router>

  )
}
export default App;
